<template>
  <v-progress-circular
    indeterminate
    size="25"
    color="primary"
  ></v-progress-circular>
</template>

<script>
export default {
  name: "BaseLoading",
};
</script>
